import { Radio, Select } from 'antd';
import React from 'react';
import { IRadioProps } from './types';


function SelectInput(props: IRadioProps) {

  return (
    <div className="radio-component">
      <div className="radio-component__label">
        {props.label}
      </div>
      <div {...props.innerProps} className="radio-component__select">
        <Radio.Group
          {...props.innerProps}
          options={props.options}
          onChange={props.onChange}
          value={props.value}
          optionType="button"
          buttonStyle="solid"
          disabled={props.disabled}
        />
      </div>
    </div>
  )
}

export default SelectInput